export const trackEvent = (event, params = {}) => {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...params });
        if (typeof window.gtag === "function") window.gtag("event", event, params);
        if (typeof window.fbq === "function") window.fbq("trackCustom", event, params);
    } catch (e) {
        /* analytics placeholders only */
    }
};
